import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // 根据认证方式检查登录状态
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    if (store.getters['auth/loggedIn']) {
                        next({ name: 'home' })
                    } else {
                        next()
                    }
                } else {
                    // 非 Firebase 模式：检查 localStorage 中的 user
                    const loggeduser = localStorage.getItem('user');
                    if (loggeduser) {
                        next({ name: 'home' })
                    } else {
                        next()
                    }
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // 根据认证方式检查登录状态
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    if (store.getters['auth/loggedIn']) {
                        next({ name: 'home' })
                    } else {
                        next()
                    }
                } else {
                    // 非 Firebase 模式：检查 localStorage 中的 user
                    const loggeduser = localStorage.getItem('user');
                    if (loggeduser) {
                        next({ name: 'home' })
                    } else {
                        next()
                    }
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index')
    },
    {
        path: '/setting/account',
        name: 'accountsetting',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/setting/account')
    },
    {
        path: '/setting/safety',
        name: 'accountsafety',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/setting/safety')
    },
    {
        path: '/setting/logs',
        name: 'actionlogs',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/setting/logs')
    },
    {
        path: '/setting/apicredentials',
        name: 'apicredentials',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/setting/apicredentials')
    },
    {
        path: '/setting/apicredentials/:id',
        name: 'apicredentialdetail',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/setting/apicredentialdetail')
    },
    {
        path: '/doc/openapi',
        name: 'openapi',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/doc/openapi')
    },
    {
        path: '/dns/list',
        name: 'dnslist',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dns/list')
    },
    {
        path: '/dns/:domain/record',
        name: 'domainrecord',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dns/record')
    },
    {
        path: '/dns/:domain/record/dnssec',
        name: 'dnssec',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dns/dnssec')
    },
    {
        path: '/dns/ptr',
        name: 'ipptr',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dns/ptrlist')
    },
    {
        path: '/dns/ptr/:id',
        name: 'ipptrrecord',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dns/ptr')
    },
    {
        path: '*',
        component: () => import('../views/pages/extend/404')
    }

]
